export default {
  // 测试
  // apihost: 'https://ynwx.zgwyzxw.cn/'
  // 中正正式
  apihost: 'https://zzwx.yzptzx.cn/'
}



// WEBPACK FOOTER //
// ./src/common/js/commonUrl.js